/* lb-priv-wall-ax daily-notice1: 月曆每日事項置頂 */
/* lb-priv-wall-av brand-enroll: 專屬頁前往報名走 /products/{handle} */
/* lb-priv-wall-at wall-tag1: hub card tagline under vendor name */
/* lb-priv-wall-am learner-surface1: validate-bookings keep sheet on block + daylabel */
(function () {
  'use strict';

  var cfgEl = document.getElementById('lb-private-courses-config');
  var cfg = {
    loggedIn: false,
    loginUrl: '/account/login',
    customerEmail: '',
    customerName: '',
    customerPhone: '',
    proxyBase: '/apps/ladybae-vendor-test'
  };
  try {
    if (cfgEl) cfg = Object.assign(cfg, JSON.parse(cfgEl.textContent || '{}'));
  } catch (e) { /* ignore */ }

  var ID4_KEY = 'lb_priv_id4';
  /** @type {Object.<string, {course: object, variantId: number}>} */
  var scheduleSelected = {};

  var hubEl = document.getElementById('lb-priv-hub');
  var wallEl = document.getElementById('lb-priv-wall');
  var vendorEl = document.getElementById('lb-priv-vendor');
  var backBtn = document.getElementById('lb-priv-back');
  var emailRow = document.getElementById('lb-priv-email-row');
  var emailInput = document.getElementById('lb-priv-email');
  var refreshBtn = document.getElementById('lb-priv-refresh');
  var loadingEl = document.getElementById('lb-priv-loading');
  var errorEl = document.getElementById('lb-priv-error');
  var noPassEl = document.getElementById('lb-priv-no-pass');
  var brandEl = document.getElementById('lb-priv-brand');
  var scheduleEl = document.getElementById('lb-priv-schedule');
  var viewSwitchEl = document.getElementById('lb-priv-view-switch');
  var passesWrap = document.getElementById('lb-priv-passes-wrap');
  var passesEl = document.getElementById('lb-priv-passes');

  var selectedVendor = null;
  var brandReqSeq = 0;
  var directoryCache = [];
  var layerView = 'brand'; /* brand | schedule */
  var scheduleMode = 'open'; /* open | registered */
  var scheduleCourses = [];
  var scheduleNotices = [];
  var scheduleTickets = [];
  var scheduleDayFilter = null;
  var scheduleCalCursor = null;
  var scheduleLoadedFor = '';
  var ticketsLoadedFor = '';
  /** True when last tickets fetch failed — fail-closed for quick enroll. */
  var ticketsLoadFailed = false;
  var quickEnrollSubmitting = false;
  var MY_TICKETS_URL = '/pages/我的活動票券-v2';
  /** Deep-link to my-tickets card (supports ?ticket=uid focus). */
  function myTicketsHrefFor(ticket) {
    var uid = String((ticket && (ticket.ticket_uid || ticket.qr_payload)) || '').trim();
    if (!uid) return MY_TICKETS_URL;
    return MY_TICKETS_URL + '?ticket=' + encodeURIComponent(uid);
  }
  /**
   * New Customer Accounts order status page (has「退回品項」).
   * Example: https://account.ladybaeshop.com/orders/7266154021093
   * Storefront /account/orders/{id} only lands on account hub — do not use.
   */
  function accountOrderHrefFor(ticket) {
    var raw = String((ticket && ticket.order_id) || '').trim();
    if (!raw) return '';
    var m = raw.match(/gid:\/\/shopify\/Order\/(\d+)/i) || raw.match(/^(\d+)$/);
    var id = m ? m[1] : '';
    if (!id) {
      m = raw.match(/(\d{6,})/);
      id = m ? m[1] : '';
    }
    return id ? ('https://account.ladybaeshop.com/orders/' + id) : '';
  }
  var brandPayloadCache = null;
  /** @type {{show_brand_page:boolean,show_schedule:boolean,default_layer:string,schedule_card_fields:object}} */
  var learnerSurface = {
    show_brand_page: true,
    show_schedule: true,
    default_layer: 'brand',
    schedule_card_fields: {
      time: true,
      venue: true,
      address: false,
      description: true,
      capacity: true,
      price: true
    }
  };

  function normalizeScheduleCardFields(raw) {
    var src = raw && typeof raw === 'object' ? raw : {};
    return {
      time: true,
      venue: src.venue !== false && src.venue !== 0 && src.venue !== '0',
      address: src.address === true || src.address === 1 || src.address === '1',
      description: src.description !== false && src.description !== 0 && src.description !== '0',
      capacity: src.capacity !== false && src.capacity !== 0 && src.capacity !== '0',
      price: src.price !== false && src.price !== 0 && src.price !== '0'
    };
  }

  function normalizeLearnerSurface(raw) {
    var src = raw && typeof raw === 'object' ? raw : {};
    var showBrand = src.show_brand_page !== false;
    var showSchedule = src.show_schedule !== false;
    if (!showBrand && !showSchedule) showSchedule = true;
    var defaultLayer = src.default_layer === 'schedule' ? 'schedule' : 'brand';
    if (showBrand && !showSchedule) defaultLayer = 'brand';
    if (!showBrand && showSchedule) defaultLayer = 'schedule';
    return {
      show_brand_page: showBrand,
      show_schedule: showSchedule,
      default_layer: defaultLayer,
      schedule_card_fields: normalizeScheduleCardFields(src.schedule_card_fields)
    };
  }

  function resolveLayerView(preferred) {
    var surface = normalizeLearnerSurface(learnerSurface);
    var want = preferred === 'schedule' ? 'schedule' : 'brand';
    if (want === 'schedule' && !surface.show_schedule) want = 'brand';
    if (want === 'brand' && !surface.show_brand_page) want = 'schedule';
    if (want === 'schedule' && !surface.show_schedule) want = 'brand';
    if (want === 'brand' && !surface.show_brand_page && surface.show_schedule) want = 'schedule';
    return want;
  }

  function pickInitialLayerView() {
    var surface = normalizeLearnerSurface(learnerSurface);
    var urlTab = queryViewParam() === 'schedule' ? 'schedule' : '';
    if (urlTab === 'schedule' && surface.show_schedule) return 'schedule';
    if (urlTab === 'schedule' && !surface.show_schedule && surface.show_brand_page) return 'brand';
    return resolveLayerView(surface.default_layer);
  }

  function baseProxy() {
    return String(cfg.proxyBase || '/apps/ladybae-vendor-test').replace(/\/$/, '');
  }

  function proxyUrl(path) {
    return baseProxy() + path;
  }

  function proxyUrlWith(path, extra) {
    var url = baseProxy() + path;
    var pairs = [];
    Object.keys(extra || {}).forEach(function (k) {
      if (extra[k] == null || extra[k] === '') return;
      pairs.push(encodeURIComponent(k) + '=' + encodeURIComponent(extra[k]));
    });
    if (!pairs.length) return url;
    return url + '?' + pairs.join('&');
  }

  function bindActivate(el, fn) {
    if (!el) return;
    el.addEventListener('click', function (e) {
      if (el.getAttribute('aria-disabled') === 'true') return;
      if (el.tagName === 'A') e.preventDefault();
      fn(e);
    });
    el.addEventListener('keydown', function (e) {
      if (el.getAttribute('aria-disabled') === 'true') return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        fn(e);
      }
    });
  }

  function setBusy(el, busy) {
    if (!el) return;
    el.setAttribute('aria-disabled', busy ? 'true' : 'false');
    el.classList.toggle('is-busy', !!busy);
  }

  function fetchJson(url, opts) {
    opts = opts || {};
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = null;
    var req = {
      credentials: 'same-origin',
      headers: Object.assign({ Accept: 'application/json' }, opts.headers || {}),
      method: opts.method || 'GET'
    };
    if (opts.body != null) {
      req.body = typeof opts.body === 'string' ? opts.body : JSON.stringify(opts.body);
      req.headers['Content-Type'] = 'application/json';
    }
    if (ctrl) {
      req.signal = ctrl.signal;
      timer = setTimeout(function () {
        try { ctrl.abort(); } catch (e) { /* ignore */ }
      }, opts.timeoutMs || 15000);
    }
    return fetch(url, req)
      .then(function (r) {
        return r.text().then(function (text) {
          var j = null;
          try { j = text ? JSON.parse(text) : null; } catch (e) { j = null; }
          return { ok: r.ok, status: r.status, j: j, raw: text };
        });
      })
      .finally(function () {
        if (timer) clearTimeout(timer);
      });
  }

  function showError(msg) {
    if (!errorEl) return;
    errorEl.hidden = !msg;
    errorEl.textContent = msg || '';
  }

  function setLoading(on) {
    if (loadingEl) loadingEl.hidden = !on;
  }

  function fmt(ts) {
    if (!ts) return '—';
    try {
      var d = new Date(ts);
      if (isNaN(d.getTime())) return String(ts);
      return d.toLocaleString('zh-TW', { timeZone: 'Asia/Taipei', hour12: false });
    } catch (e) {
      return String(ts);
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initialOf(name) {
    var s = String(name || '').trim();
    return s ? s.charAt(0).toUpperCase() : '?';
  }

  function queryVendorParam() {
    try {
      return new URL(window.location.href).searchParams.get('vendor') || '';
    } catch (e) {
      return '';
    }
  }

  function setUrlVendor(slug) {
    try {
      var u = new URL(window.location.href);
      if (slug) u.searchParams.set('vendor', slug);
      else u.searchParams.delete('vendor');
      window.history.replaceState({}, '', u.toString());
    } catch (e) { /* ignore */ }
  }

  function queryViewParam() {
    // Prefer ?tab= — Shopify reserves ?view= for alternate templates (page.*.schedule).
    try {
      var u = new URL(window.location.href);
      var tab = String(u.searchParams.get('tab') || '').toLowerCase();
      if (tab) return tab;
      return String(u.searchParams.get('view') || '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  function setUrlView(view) {
    try {
      var u = new URL(window.location.href);
      // Drop reserved ?view= so Shopify keeps page.private-courses
      u.searchParams.delete('view');
      if (view === 'schedule') u.searchParams.set('tab', 'schedule');
      else u.searchParams.delete('tab');
      window.history.replaceState({}, '', u.toString());
    } catch (e) { /* ignore */ }
  }

  function monthStart(d) {
    return new Date(d.getFullYear(), d.getMonth(), 1);
  }

  function pad2(n) {
    n = Number(n) || 0;
    return (n < 10 ? '0' : '') + n;
  }

  function isoWeekdayYmd(y, m, d) {
    return new Date(Date.UTC(y, m - 1, d)).getUTCDay() || 7;
  }

  function isoWeekNumberYmd(y, m, d) {
    var utc = new Date(Date.UTC(y, m - 1, d));
    var dow = utc.getUTCDay() || 7;
    var thu = new Date(utc);
    thu.setUTCDate(utc.getUTCDate() + 4 - dow);
    var yearStart = new Date(Date.UTC(thu.getUTCFullYear(), 0, 1));
    return Math.ceil((((thu.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
  }

  function noticeMatchesDay(n, y, m, d) {
    if (!n || n.is_enabled === false) return false;
    var kind = String(n.rule_kind || '');
    var days = n.weekdays || [];
    if (kind === 'WEEKLY') return days.indexOf(isoWeekdayYmd(y, m, d)) >= 0;
    if (kind === 'ISO_WEEK') {
      var odd = isoWeekNumberYmd(y, m, d) % 2 === 1;
      if (n.iso_parity === 'ODD' && !odd) return false;
      if (n.iso_parity === 'EVEN' && odd) return false;
      return days.indexOf(isoWeekdayYmd(y, m, d)) >= 0;
    }
    if (kind === 'MONTHLY_DAYS') return (n.month_days || []).indexOf(d) >= 0;
    return false;
  }

  function expandNoticesForMonth(notices, y, m) {
    var last = new Date(y, m, 0).getDate();
    var out = [];
    (notices || []).forEach(function (n) {
      if (!n || n.is_enabled === false) return;
      for (var d = 1; d <= last; d++) {
        if (!noticeMatchesDay(n, y, m, d)) continue;
        out.push({
          id: n.id,
          title: n.title,
          calendar_color: n.calendar_color,
          sort_order: n.sort_order || 0,
          ymd: y + '-' + pad2(m) + '-' + pad2(d),
          day: d
        });
      }
    });
    out.sort(function (a, b) {
      if (a.ymd !== b.ymd) return a.ymd < b.ymd ? -1 : 1;
      if (a.sort_order !== b.sort_order) return a.sort_order - b.sort_order;
      return Number(a.id) - Number(b.id);
    });
    return out;
  }

  function noticesForYmd(ymd) {
    if (!ymd) return [];
    var parts = String(ymd).split('-');
    var y = Number(parts[0]);
    var m = Number(parts[1]);
    if (!y || !m) return [];
    return expandNoticesForMonth(scheduleNotices, y, m).filter(function (n) {
      return n.ymd === ymd;
    });
  }

  function noticeChipColor(n) {
    var raw = String((n && n.calendar_color) || '').trim();
    if (/^#[0-9A-Fa-f]{6}$/.test(raw)) return raw;
    return '#F8D7DA';
  }

  function renderNoticeChip(n, extraClass) {
    return '<div class="lb-priv__sched-notice' + (extraClass ? ' ' + extraClass : '') +
      '" style="background:' + escapeHtml(noticeChipColor(n)) + '">' +
      escapeHtml(n.title || '每日事項') +
      '</div>';
  }

  function renderNoticeRow(n) {
    return (
      '<div class="lb-priv__sched-row lb-priv__sched-row--notice">' +
        '<div>' +
          '<div class="lb-priv__sched-row-title">' + escapeHtml(n.title || '每日事項') + '</div>' +
          '<div class="lb-priv__sched-row-meta">每日事項 · 無需報名</div>' +
        '</div>' +
        '<span class="lb-priv__sched-badge lb-priv__sched-badge--notice">知悉</span>' +
      '</div>'
    );
  }

  function ymdTPE(dateObj) {
    var d = dateObj instanceof Date ? dateObj : new Date(dateObj);
    if (Number.isNaN(d.getTime())) return '';
    var parts = new Intl.DateTimeFormat('zh-TW', {
      timeZone: 'Asia/Taipei',
      year: 'numeric', month: '2-digit', day: '2-digit'
    }).formatToParts(d);
    var m = {};
    parts.forEach(function (p) { m[p.type] = p.value; });
    return (m.year || '') + '-' + (m.month || '') + '-' + (m.day || '');
  }

  function courseYmd(c) {
    if (!c || !c.start_at) return '';
    return ymdTPE(c.start_at);
  }

  function ticketYmd(t) {
    if (!t) return '';
    var start = t.event_start_at || t.start_at;
    return start ? ymdTPE(start) : '';
  }

  function fmtTimeRange(start, end) {
    function hm(v) {
      if (!v) return '';
      var d = new Date(v);
      if (Number.isNaN(d.getTime())) return '';
      var parts = new Intl.DateTimeFormat('zh-TW', {
        timeZone: 'Asia/Taipei', hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(d);
      var m = {};
      parts.forEach(function (p) { m[p.type] = p.value; });
      return (m.hour || '') + ':' + (m.minute || '');
    }
    var a = hm(start);
    var b = hm(end);
    if (a && b) return a + ' ～ ' + b;
    return a || b || '';
  }

  /** Calendar meta: time / venue / description (values only, no field labels). */
  function clipMetaText(raw, maxLen) {
    var s = String(raw || '').replace(/\s+/g, ' ').trim();
    if (!s) return '';
    var lim = maxLen || 48;
    if (s.length <= lim) return s;
    return s.slice(0, lim - 1) + '…';
  }

  function scheduleCourseMeta(it, priceHint, fields) {
    var f = normalizeScheduleCardFields(
      fields || (learnerSurface && learnerSurface.schedule_card_fields)
    );
    var parts = [];
    if (f.time) {
      var time = fmtTimeRange(it.start_at, it.end_at);
      if (time) parts.push(time);
    }
    if (f.venue) {
      var venue = clipMetaText(it.venue_name, 40);
      if (venue) parts.push(venue);
    }
    if (f.address) {
      var addr = clipMetaText(it.address, 48);
      if (addr) parts.push(addr);
    }
    if (f.description) {
      var desc = clipMetaText(it.description, 48);
      if (desc) parts.push(desc);
    }
    if (f.capacity && it.capacity_total > 0) {
      parts.push('名額 ' + it.sold_count + '/' + it.capacity_total);
    }
    if (f.price) {
      var price = String(priceHint || '').replace(/^\s*[·•]\s*/, '').trim();
      if (price) parts.push(price);
    }
    return parts.join(' / ');
  }

  function weekdayLabelTPE(ymd) {
    if (!ymd) return '';
    var d = new Date(ymd + 'T12:00:00+08:00');
    if (Number.isNaN(d.getTime())) return ymd;
    var parts = new Intl.DateTimeFormat('zh-TW', {
      timeZone: 'Asia/Taipei', weekday: 'short', month: 'numeric', day: 'numeric'
    }).formatToParts(d);
    var m = {};
    parts.forEach(function (p) { m[p.type] = p.value; });
    var month = String(m.month || '').replace(/^0+/, '');
    var day = String(m.day || '').replace(/^0+/, '');
    if (!month || !day) return m.weekday || ymd;
    return (m.weekday || '') + month + '/' + day;
  }

  function findVendorMeta(slug) {
    for (var i = 0; i < directoryCache.length; i++) {
      if (directoryCache[i].slug_handle === slug) return directoryCache[i];
    }
    return { slug_handle: slug, name: slug, logo_url: null, has_pass: false, eligibility_reason_hint: '' };
  }

  function productUrl(productId, title, productPath) {
    var path = String(productPath || '').trim();
    if (path.indexOf('/products/') === 0) return path;
    if (title) return '/search?q=' + encodeURIComponent(String(title)) + '&type=product';
    return null;
  }

  function coverUrl(c) {
    if (!c) return '';
    var u = String(c.cover_image_url || '').trim();
    if (/^https?:\/\//i.test(u)) return u;
    var raw = c.images_json;
    if (typeof raw === 'string') {
      try { raw = JSON.parse(raw); } catch (e) { raw = null; }
    }
    if (Array.isArray(raw) && raw.length) {
      var first = raw[0];
      if (typeof first === 'string' && /^https?:\/\//i.test(first)) return first;
      if (first && first.src && /^https?:\/\//i.test(String(first.src))) return String(first.src);
    }
    return '';
  }

  function isCourseEnded(c) {
    if (!c) return false;
    if (c.is_ended === true) return true;
    if (!c.start_at) return false;
    var t = Date.parse(String(c.start_at));
    return Number.isFinite(t) && Date.now() >= t;
  }

  function courseCard(c, variant) {
    var v = variant || 'grid';
    var ended = isCourseEnded(c);
    var href = productUrl(c.shopify_product_id, c.title, c.product_url);
    var link = ended
      ? '<span class="lb-priv__sched-badge lb-priv__sched-badge--ended">已結束</span>'
      : href
        ? '<a class="lb-priv__btn" href="' + escapeHtml(href) + '">前往報名</a>'
        : '<span class="lb-priv__meta">商品尚未就緒</span>';
    var cover = coverUrl(c);
    var media = cover
      ? '<div class="lb-priv__card-media"><img src="' + escapeHtml(cover) +
        '" alt="" loading="lazy" decoding="async"></div>'
      : '<div class="lb-priv__card-media lb-priv__card-media--ph" aria-hidden="true"></div>';
    return (
      '<article class="lb-priv__card lb-priv__card--' + escapeHtml(v) +
        (ended ? ' is-ended' : '') + '">' +
        media +
        '<div class="lb-priv__card-body">' +
          '<h3>' + escapeHtml(c.title || '課程') + '</h3>' +
          '<div class="lb-priv__meta">開課：' + escapeHtml(fmt(c.start_at)) + '</div>' +
          (c.eligibility_label
            ? '<div class="lb-priv__label">' + escapeHtml(c.eligibility_label) + '</div>'
            : '') +
          '<div class="lb-priv__card-cta">' + link + '</div>' +
        '</div>' +
      '</article>'
    );
  }

  function renderHeroCarousel(filled) {
    if (!filled.length) return '';
    var slides = filled.map(function (s, i) {
      return (
        '<div class="lb-priv__carousel-slide' + (i === 0 ? ' is-active' : '') +
        '" data-slide="' + i + '" role="group" aria-label="' + (i + 1) + ' / ' + filled.length + '">' +
        courseCard(s.listing, 'hero') +
        '</div>'
      );
    }).join('');
    var dots = filled.map(function (_s, i) {
      return '<span class="lb-priv__carousel-dot' + (i === 0 ? ' is-active' : '') +
        '" data-go="' + i + '" role="button" tabindex="0" aria-label="第 ' + (i + 1) + ' 張"></span>';
    }).join('');
    var controls = filled.length > 1
      ? (
          '<span class="lb-priv__carousel-btn lb-priv__carousel-btn--prev" data-dir="-1" role="button" tabindex="0" aria-label="上一張">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>' +
          '</span>' +
          '<span class="lb-priv__carousel-btn lb-priv__carousel-btn--next" data-dir="1" role="button" tabindex="0" aria-label="下一張">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>' +
          '</span>' +
          '<div class="lb-priv__carousel-dots">' + dots + '</div>'
        )
      : '';
    return (
      '<div class="lb-priv__carousel" data-lb-carousel>' +
        '<div class="lb-priv__carousel-viewport">' +
          '<div class="lb-priv__carousel-track">' + slides + '</div>' +
          controls +
        '</div>' +
      '</div>'
    );
  }

  function initCarousels(root) {
    if (!root) return;
    root.querySelectorAll('[data-lb-carousel]').forEach(function (el) {
      if (el._lbCarouselBound) return;
      el._lbCarouselBound = true;
      var slides = el.querySelectorAll('.lb-priv__carousel-slide');
      var dots = el.querySelectorAll('.lb-priv__carousel-dot');
      if (slides.length < 2) return;
      var idx = 0;
      var timer = null;
      function show(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }
      function next(delta) { show(idx + delta); restart(); }
      function restart() {
        if (timer) clearInterval(timer);
        timer = setInterval(function () { show(idx + 1); }, 5000);
      }
      el.querySelectorAll('[data-dir]').forEach(function (btn) {
        bindActivate(btn, function () {
          next(parseInt(btn.getAttribute('data-dir'), 10) || 1);
        });
      });
      dots.forEach(function (dot) {
        bindActivate(dot, function () {
          show(parseInt(dot.getAttribute('data-go'), 10) || 0);
          restart();
        });
      });
      el.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
      el.addEventListener('mouseleave', restart);
      restart();
    });
  }

  // ── Wall ───────────────────────────────────────────────────────────────
  function rootEl() {
    return document.getElementById('lb-private-courses-root');
  }

  function resetScheduleState() {
    scheduleCourses = [];
    scheduleNotices = [];
    scheduleTickets = [];
    scheduleDayFilter = null;
    scheduleCalCursor = null;
    scheduleLoadedFor = '';
    ticketsLoadedFor = '';
    ticketsLoadFailed = false;
    quickEnrollSubmitting = false;
    scheduleMode = 'open';
    brandPayloadCache = null;
    scheduleSelected = {};
    renderQuickBar();
  }

  function readStoredId4() {
    try { return String(localStorage.getItem(ID4_KEY) || '').trim(); } catch (e) { return ''; }
  }
  function writeStoredId4(v) {
    try { if (v) localStorage.setItem(ID4_KEY, v); } catch (e) { /* ignore */ }
  }

  function uuid() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      var v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function isValidYYYYMM(s) {
    if (!/^\d{6}$/.test(s)) return false;
    var y = Number(s.slice(0, 4));
    var m = Number(s.slice(4, 6));
    if (y < 1900 || y > 2100) return false;
    if (m < 1 || m > 12) return false;
    return true;
  }

  function fmtNtd(price) {
    var n = Number(price);
    if (!Number.isFinite(n)) n = 0;
    return 'NT$' + Math.round(n).toLocaleString('zh-TW');
  }

  function fmtDatetimeLabel(start) {
    if (!start) return '';
    var d = new Date(start);
    if (Number.isNaN(d.getTime())) return String(start);
    var parts = new Intl.DateTimeFormat('zh-TW', {
      timeZone: 'Asia/Taipei',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(d);
    var m = {};
    parts.forEach(function (p) { m[p.type] = p.value; });
    if (!m.year || !m.month || !m.day) return String(start);
    return m.year + '/' + m.month + '/' + m.day + ' ' + (m.hour || '00') + ':' + (m.minute || '00');
  }

  function activeTicketStates() {
    return { usable: 1, pending_vendor: 1 };
  }

  function numericShopId(raw) {
    var s = String(raw || '').trim();
    if (!s) return '';
    var m = s.match(/\/(?:Product|ProductVariant)\/(\d+)/i);
    if (m) return m[1];
    if (/^\d+$/.test(s)) return s;
    return s;
  }

  function findCourseForTicket(t) {
    if (!t) return null;
    var tEventId = String(t.event_id || '').trim();
    var tPid = numericShopId(t.product_id);
    var tTitle = String(t.event_title || t.product_title || '').trim().toLowerCase();
    var tDay = ticketYmd(t);
    var fuzzy = null;
    for (var i = 0; i < scheduleCourses.length; i++) {
      var c = scheduleCourses[i];
      if (!c) continue;
      var eventId = String(c.event_id || '').trim();
      if (tEventId && eventId && tEventId === eventId) return c;
      if (tEventId && eventId) continue;
      var productId = numericShopId(c.shopify_product_id);
      var title = String(c.title || '').trim().toLowerCase();
      var day = courseYmd(c);
      if (tDay && day && tDay === day) {
        if (tPid && productId && tPid === productId) return c;
        if (tTitle && title && tTitle === title) fuzzy = fuzzy || c;
      }
    }
    return fuzzy;
  }

  function coursePriceHint(it) {
    if (!it || !Array.isArray(it.variants) || !it.variants.length) return '';
    var prices = it.variants
      .filter(function (v) { return Number(v.shopify_variant_id) > 0; })
      .map(function (v) { return Number(v.price) || 0; });
    if (!prices.length) return '';
    var minP = Math.min.apply(null, prices);
    var maxP = Math.max.apply(null, prices);
    return minP === maxP ? ' · ' + fmtNtd(minP) : ' · ' + fmtNtd(minP) + ' 起';
  }

  function ticketScheduleMeta(t) {
    var course = findCourseForTicket(t);
    return scheduleCourseMeta({
      start_at: (course && course.start_at) || t.event_start_at,
      end_at: (course && course.end_at) || t.event_end_at,
      venue_name: (course && course.venue_name) || t.venue_name,
      address: (course && course.address) || t.address,
      description: course && course.description,
      capacity_total: course ? course.capacity_total : 0,
      sold_count: course ? course.sold_count : 0
    }, coursePriceHint(course));
  }

  function isAlreadyRegistered(course) {
    if (!course) return false;
    var eventId = String(course.event_id || '').trim();
    var productId = numericShopId(course.shopify_product_id);
    var title = String(course.title || '').trim().toLowerCase();
    var day = courseYmd(course);
    for (var i = 0; i < scheduleTickets.length; i++) {
      var t = scheduleTickets[i];
      if (!t) continue;
      var st = ticketStatusKey(t);
      if (!activeTicketStates()[st]) continue;
      var tEventId = String(t.event_id || '').trim();
      // Prefer exact event_id match.
      if (eventId && tEventId && eventId === tEventId) return true;
      // If both sides have event_id and they differ, do not fuzzy-match.
      if (eventId && tEventId) continue;
      var tPid = numericShopId(t.product_id);
      var tTitle = String(t.event_title || t.product_title || '').trim().toLowerCase();
      var tDay = ticketYmd(t);
      // Fallbacks only when event_id missing; require same calendar day.
      if (day && tDay && day === tDay) {
        if (productId && tPid && productId === tPid) return true;
        if (title && tTitle && title === tTitle) return true;
      }
    }
    return false;
  }

  function courseSelectable(it) {
    if (ticketsLoadFailed) return false;
    return !!(
      it &&
      it.can_quick_add &&
      !it.is_full &&
      !isCourseEnded(it) &&
      !isAlreadyRegistered(it)
    );
  }

  function pruneInvalidSelections() {
    var changed = false;
    Object.keys(scheduleSelected).forEach(function (id) {
      var row = scheduleSelected[id];
      var course = null;
      for (var i = 0; i < scheduleCourses.length; i++) {
        if (String(scheduleCourses[i].id) === String(id)) {
          course = scheduleCourses[i];
          break;
        }
      }
      if (!course || !courseSelectable(course)) {
        delete scheduleSelected[id];
        changed = true;
        return;
      }
      // Refresh course snapshot + ensure variant still valid
      var vids = (Array.isArray(course.variants) ? course.variants : [])
        .map(function (v) { return Number(v.shopify_variant_id); })
        .filter(function (n) { return n > 0; });
      if (!vids.length) {
        delete scheduleSelected[id];
        changed = true;
        return;
      }
      if (vids.indexOf(Number(row.variantId)) < 0) {
        scheduleSelected[id] = { course: course, variantId: vids[0] };
        changed = true;
      } else {
        scheduleSelected[id] = { course: course, variantId: Number(row.variantId) };
      }
    });
    if (changed) renderQuickBar();
    return changed;
  }

  function defaultVariantId(it) {
    var variants = Array.isArray(it && it.variants) ? it.variants : [];
    for (var i = 0; i < variants.length; i++) {
      var vid = Number(variants[i].shopify_variant_id);
      if (vid > 0) return vid;
    }
    return 0;
  }

  function selectedList() {
    return Object.keys(scheduleSelected).map(function (k) { return scheduleSelected[k]; });
  }

  function selectedTotal() {
    var total = 0;
    selectedList().forEach(function (row) {
      var variants = Array.isArray(row.course.variants) ? row.course.variants : [];
      for (var i = 0; i < variants.length; i++) {
        if (Number(variants[i].shopify_variant_id) === Number(row.variantId)) {
          total += Number(variants[i].price) || 0;
          break;
        }
      }
    });
    return total;
  }

  function toggleSelectCourse(courseId, checked) {
    var id = String(courseId || '');
    if (!id) return;
    if (!checked) {
      delete scheduleSelected[id];
      renderQuickBar();
      return;
    }
    var course = null;
    for (var i = 0; i < scheduleCourses.length; i++) {
      if (String(scheduleCourses[i].id) === id) {
        course = scheduleCourses[i];
        break;
      }
    }
    if (!course || !courseSelectable(course)) return;
    var vid = defaultVariantId(course);
    if (!vid) return;
    scheduleSelected[id] = { course: course, variantId: vid };
    renderQuickBar();
  }

  function ensureQuickUi() {
    if (!document.getElementById('lb-priv-quick-bar')) {
      var bar = document.createElement('div');
      bar.id = 'lb-priv-quick-bar';
      bar.className = 'lb-priv__quick-bar';
      bar.hidden = true;
      bar.innerHTML =
        '<div class="lb-priv__quick-bar-inner">' +
          '<div class="lb-priv__quick-bar-meta">' +
            '<strong data-quick-count>已選 0 堂</strong>' +
            '<span data-quick-total>合計 NT$0</span>' +
          '</div>' +
          '<span class="lb-priv__quick-cta" role="button" tabindex="0" data-quick-open>確認報名</span>' +
        '</div>';
      document.body.appendChild(bar);
      var openBtn = bar.querySelector('[data-quick-open]');
      if (openBtn) {
        bindActivate(openBtn, function () { openConfirmSheet(); });
      }
    }
    if (!document.getElementById('lb-priv-confirm')) {
      var sheet = document.createElement('div');
      sheet.id = 'lb-priv-confirm';
      sheet.className = 'lb-priv__confirm';
      sheet.hidden = true;
      sheet.innerHTML =
        '<div class="lb-priv__confirm-backdrop" data-confirm-close></div>' +
        '<div class="lb-priv__confirm-panel" role="dialog" aria-modal="true" aria-label="確認報名">' +
          '<div class="lb-priv__confirm-head">' +
            '<strong>確認報名</strong>' +
            '<span class="lb-priv__confirm-x" role="button" tabindex="0" data-confirm-close aria-label="關閉">×</span>' +
          '</div>' +
          '<p class="lb-priv__confirm-hint">學員資料將套用到以下全部課程（報名本人）。</p>' +
          '<div class="lb-priv__confirm-list" data-confirm-list></div>' +
          '<div class="lb-priv__confirm-form">' +
            '<label>學員姓名<input data-qf="_lb_name" required autocomplete="name"></label>' +
            '<label>手機<input data-qf="_lb_phone" inputmode="tel" required autocomplete="tel"></label>' +
            '<label>西元年生日年月（YYYYMM）' +
              '<input data-qf="_lb_id4" inputmode="numeric" maxlength="6" minlength="6" pattern="[0-9]{6}" placeholder="202009" required>' +
            '</label>' +
            '<label>備註（選填）<input data-qf="_lb_note"></label>' +
          '</div>' +
          '<div class="lb-priv__confirm-warn" data-confirm-warn></div>' +
          '<div class="lb-priv__confirm-actions">' +
            '<span class="lb-priv__quick-cta lb-priv__quick-cta--ghost" role="button" tabindex="0" data-confirm-close>返回</span>' +
            '<span class="lb-priv__quick-cta" role="button" tabindex="0" data-confirm-submit>前往結帳</span>' +
          '</div>' +
        '</div>';
      document.body.appendChild(sheet);
      sheet.addEventListener('click', function (e) {
        if (e.target.closest('[data-confirm-close]')) {
          closeConfirmSheet();
          return;
        }
        if (e.target.closest('[data-confirm-submit]')) {
          submitQuickEnroll();
          return;
        }
        var rm = e.target.closest('[data-confirm-remove]');
        if (rm) {
          toggleSelectCourse(rm.getAttribute('data-confirm-remove'), false);
          openConfirmSheet();
          renderSchedule();
        }
        var sel = e.target.closest('[data-confirm-variant]');
        if (sel && sel.tagName === 'SELECT') {
          var cid = sel.getAttribute('data-confirm-variant');
          if (scheduleSelected[cid]) {
            scheduleSelected[cid].variantId = Number(sel.value) || 0;
            renderQuickBar();
            openConfirmSheet();
          }
        }
      });
      var id4 = sheet.querySelector('input[data-qf="_lb_id4"]');
      if (id4) {
        id4.addEventListener('input', function () {
          id4.value = String(id4.value || '').replace(/\D/g, '').slice(0, 6);
        });
      }
    }
  }

  function renderQuickBar() {
    ensureQuickUi();
    var bar = document.getElementById('lb-priv-quick-bar');
    if (!bar) return;
    var n = selectedList().length;
    var show = scheduleMode === 'open' && !!selectedVendor && n > 0;
    bar.hidden = !show;
    var countEl = bar.querySelector('[data-quick-count]');
    var totalEl = bar.querySelector('[data-quick-total]');
    if (countEl) countEl.textContent = '已選 ' + n + ' 堂';
    if (totalEl) totalEl.textContent = '合計 ' + fmtNtd(selectedTotal());
  }

  function closeConfirmSheet() {
    var sheet = document.getElementById('lb-priv-confirm');
    if (sheet) sheet.hidden = true;
  }

  function openConfirmSheet() {
    ensureQuickUi();
    var sheet = document.getElementById('lb-priv-confirm');
    if (!sheet) return;
    var list = selectedList();
    if (!list.length) {
      closeConfirmSheet();
      return;
    }
    var listEl = sheet.querySelector('[data-confirm-list]');
    if (listEl) {
      listEl.innerHTML = list.map(function (row) {
        var c = row.course;
        var variants = (Array.isArray(c.variants) ? c.variants : []).filter(function (v) {
          return Number(v.shopify_variant_id) > 0;
        });
        var variantHtml = '';
        if (variants.length > 1) {
          variantHtml =
            '<select data-confirm-variant="' + escapeHtml(String(c.id)) + '">' +
            variants.map(function (v) {
              var vid = Number(v.shopify_variant_id);
              return (
                '<option value="' + vid + '"' +
                (vid === Number(row.variantId) ? ' selected' : '') +
                '>' + escapeHtml(v.name || '票種') + ' · ' + fmtNtd(v.price) + '</option>'
              );
            }).join('') +
            '</select>';
        } else if (variants.length === 1) {
          variantHtml =
            '<div class="lb-priv__confirm-price">' +
              escapeHtml(variants[0].name || '票種') + ' · ' + fmtNtd(variants[0].price) +
            '</div>';
        }
        return (
          '<div class="lb-priv__confirm-item">' +
            '<div>' +
              '<div class="lb-priv__confirm-title">' + escapeHtml(c.title || '課程') + '</div>' +
              '<div class="lb-priv__confirm-meta">' +
                escapeHtml(fmtTimeRange(c.start_at, c.end_at)) +
              '</div>' +
              variantHtml +
            '</div>' +
            '<span class="lb-priv__link" role="button" tabindex="0" data-confirm-remove="' +
              escapeHtml(String(c.id)) + '">移除</span>' +
          '</div>'
        );
      }).join('');
    }
    var nameInp = sheet.querySelector('input[data-qf="_lb_name"]');
    var phoneInp = sheet.querySelector('input[data-qf="_lb_phone"]');
    var id4Inp = sheet.querySelector('input[data-qf="_lb_id4"]');
    if (nameInp && !nameInp.value && cfg.customerName) nameInp.value = cfg.customerName;
    if (phoneInp && !phoneInp.value && cfg.customerPhone) phoneInp.value = cfg.customerPhone;
    if (id4Inp && !id4Inp.value) {
      var stored = readStoredId4();
      if (stored) id4Inp.value = stored;
    }
    var warn = sheet.querySelector('[data-confirm-warn]');
    if (warn) warn.textContent = '';
    sheet.hidden = false;
  }

  function buildQuickCartItems(form) {
    var items = [];
    selectedList().forEach(function (row) {
      var c = row.course;
      var props = {
        _lb_ticket_uid: uuid(),
        // Prefer event_id_preview (ingest lookup key); fallback listing id only if missing.
        _lb_session_id: String(c.event_id || c.id || ''),
        _lb_event_title: String(c.title || ''),
        // Align with picker datetime_label style (YYYY/MM/DD HH:mm, Taipei).
        _lb_start_at: fmtDatetimeLabel(c.start_at),
        _lb_venue: String(c.venue_name || ''),
        _lb_address: String(c.address || ''),
        _lb_maps_url: String(c.maps_url || ''),
        _lb_vendor_code: String(c.slug_handle || selectedVendor || ''),
        _lb_vendor_name: String((findVendorMeta(selectedVendor).name) || ''),
        _lb_name: form.name,
        _lb_phone: form.phone,
        _lb_id4: form.id4,
        _lb_note: form.note || ''
      };
      items.push({
        id: Number(row.variantId),
        quantity: 1,
        properties: props,
        _lb_course_title: String(c.title || '')
      });
    });
    return items;
  }

  function submitQuickEnroll() {
    var sheet = document.getElementById('lb-priv-confirm');
    if (!sheet) return;
    if (quickEnrollSubmitting) return;
    var warn = sheet.querySelector('[data-confirm-warn]');
    var name = String((sheet.querySelector('input[data-qf="_lb_name"]') || {}).value || '').trim();
    var phone = String((sheet.querySelector('input[data-qf="_lb_phone"]') || {}).value || '').trim();
    var id4 = String((sheet.querySelector('input[data-qf="_lb_id4"]') || {}).value || '').trim();
    var note = String((sheet.querySelector('input[data-qf="_lb_note"]') || {}).value || '').trim();
    if (!name || !phone || !id4) {
      if (warn) warn.textContent = '請填寫姓名、手機與生日年月。';
      return;
    }
    if (!isValidYYYYMM(id4)) {
      if (warn) warn.textContent = '生日年月需為 6 碼 YYYYMM（例如 202009）。';
      return;
    }

    var submitBtn = sheet.querySelector('[data-confirm-submit]');
    quickEnrollSubmitting = true;
    if (submitBtn) setBusy(submitBtn, true);
    if (warn) warn.textContent = '確認名額與已報名狀態…';

    // Force refresh schedule + tickets, then prune invalid selections before cart/add.
    scheduleLoadedFor = '';
    ticketsLoadedFor = '';
    ticketsLoadFailed = false;
    var scheduleOk = false;
    var schedulePromise = fetchJson(
      proxyUrlWith('/private/vendor-schedule', { vendor: selectedVendor }),
      { timeoutMs: 15000 }
    ).then(function (res) {
      if (res.ok && res.j && res.j.ok) {
        scheduleCourses = Array.isArray(res.j.courses) ? res.j.courses : [];
        scheduleNotices = Array.isArray(res.j.notices) ? res.j.notices : [];
        if (res.j.learner_surface) {
          learnerSurface = normalizeLearnerSurface(res.j.learner_surface);
        }
        scheduleLoadedFor = selectedVendor;
        scheduleOk = true;
      }
    });
    var ticketsPromise = ensureTicketsLoaded(true);

    Promise.all([schedulePromise, ticketsPromise]).then(function (bundle) {
      var ticketsResult = bundle[1] || { ok: false };
      if (!scheduleOk) {
        if (warn) warn.textContent = '無法重新確認課表，請稍後再試。';
        if (submitBtn) setBusy(submitBtn, false);
        quickEnrollSubmitting = false;
        return;
      }
      if (!ticketsResult.ok) {
        if (warn) warn.textContent = '無法確認已報名狀態，請稍後再試。';
        if (submitBtn) setBusy(submitBtn, false);
        quickEnrollSubmitting = false;
        renderSchedule();
        return;
      }
      var pruned = pruneInvalidSelections();
      if (!selectedList().length) {
        if (warn) {
          warn.textContent = pruned
            ? '所選課程已額滿、已結束或您已報名，請重新選擇。'
            : '請至少選擇一堂課。';
        }
        if (submitBtn) setBusy(submitBtn, false);
        quickEnrollSubmitting = false;
        renderSchedule();
        closeConfirmSheet();
        return;
      }
      // After prune, stop for re-confirm — do not silently checkout remaining items.
      if (pruned) {
        openConfirmSheet();
        if (warn) {
          warn.textContent = '部分課程已額滿、已結束或您已報名，已更新清單，請再次確認後送出。';
        }
        if (submitBtn) setBusy(submitBtn, false);
        quickEnrollSubmitting = false;
        renderSchedule();
        return;
      }

      var listingIds = selectedList().map(function (row) {
        return Number(row.course && row.course.id);
      }).filter(function (n) { return n > 0; });
      if (warn) warn.textContent = '確認報名資格…';
      return fetchJson(proxyUrl('/private/validate-bookings'), {
        method: 'POST',
        body: { vendor: selectedVendor, listing_ids: listingIds },
        timeoutMs: 15000
      }).then(function (vres) {
        if (!vres.ok || !vres.j || !vres.j.ok) {
          var vMsg = (vres.j && vres.j.error && vres.j.error.message) ||
            (vres.j && vres.j.message) || '無法確認報名資格，請稍後再試。';
          if (warn) warn.textContent = vMsg;
          if (submitBtn) setBusy(submitBtn, false);
          quickEnrollSubmitting = false;
          return;
        }
        var allowed = {};
        (Array.isArray(vres.j.allowed_ids) ? vres.j.allowed_ids : []).forEach(function (id) {
          allowed[String(id)] = true;
        });
        var blocked = false;
        Object.keys(scheduleSelected).forEach(function (id) {
          if (!allowed[String(id)]) {
            delete scheduleSelected[id];
            blocked = true;
          }
        });
        if (blocked) {
          renderQuickBar();
          renderSchedule();
          openConfirmSheet();
          if (warn) {
            var endedBlocked = (Array.isArray(vres.j.results) ? vres.j.results : []).some(
              function (r) { return r && r.code === 'EVENT_ALREADY_STARTED'; }
            );
            warn.textContent = !selectedList().length
              ? (endedBlocked
                ? '所選課程已結束，無法報名，請重新選擇。'
                : '所選課程目前無法報名（資格未涵蓋或課程狀態異常），請重新選擇。')
              : (endedBlocked
                ? '部分課程已結束，已更新清單，請再次確認後送出。'
                : '部分課程目前無法報名，已更新清單，請再次確認後送出。');
          }
          if (submitBtn) setBusy(submitBtn, false);
          quickEnrollSubmitting = false;
          return;
        }

        var items = buildQuickCartItems({ name: name, phone: phone, id4: id4, note: note });
        if (!items.length) {
          if (warn) warn.textContent = '請至少選擇一堂課。';
          if (submitBtn) setBusy(submitBtn, false);
          quickEnrollSubmitting = false;
          return;
        }
        if (warn) warn.textContent = '加入購物車中…';
        continueQuickEnrollAdd(items, id4, warn, submitBtn);
      });
    }).catch(function () {
      if (warn) warn.textContent = '無法重新確認課表，請稍後再試。';
      if (submitBtn) setBusy(submitBtn, false);
      quickEnrollSubmitting = false;
    });
  }

  function continueQuickEnrollAdd(items, id4, warn, submitBtn) {
    if (!items || !items.length) {
      if (warn) warn.textContent = '請至少選擇一堂課。';
      if (submitBtn) setBusy(submitBtn, false);
      quickEnrollSubmitting = false;
      return;
    }
    var payloadItems = items.map(function (it) {
      return { id: it.id, quantity: 1, properties: it.properties };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payloadItems })
    })
      .then(function (res) {
        if (res.ok) {
          writeStoredId4(id4);
          window.location.href = '/checkout';
          return null;
        }
        return addItemsSequentially(items).then(function (result) {
          if (result.okCount === items.length) {
            writeStoredId4(id4);
            window.location.href = '/checkout';
            return;
          }
          if (result.okCount > 0) {
            writeStoredId4(id4);
            if (warn) {
              warn.textContent =
                '已加入 ' + result.okCount + ' 堂，另有 ' +
                result.failTitles.length + ' 堂失敗：' +
                result.failTitles.slice(0, 3).join('、') +
                '。將前往購物車。';
            }
            setTimeout(function () { window.location.href = '/cart'; }, 1200);
            return;
          }
          if (warn) warn.textContent = '加入購物車失敗，請改從商品頁報名或稍後再試。';
          if (submitBtn) setBusy(submitBtn, false);
          quickEnrollSubmitting = false;
        });
      })
      .catch(function () {
        if (warn) warn.textContent = '網路錯誤，請稍後再試。';
        if (submitBtn) setBusy(submitBtn, false);
        quickEnrollSubmitting = false;
      });
  }

  function addItemsSequentially(items) {
    var okCount = 0;
    var failTitles = [];
    var chain = Promise.resolve();
    items.forEach(function (it) {
      chain = chain.then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: it.id, quantity: 1, properties: it.properties }]
          })
        }).then(function (res) {
          if (res.ok) okCount += 1;
          else failTitles.push(it._lb_course_title || String(it.id));
        }).catch(function () {
          failTitles.push(it._lb_course_title || String(it.id));
        });
      });
    });
    return chain.then(function () {
      return { okCount: okCount, failTitles: failTitles };
    });
  }

  function showHub() {
    selectedVendor = null;
    layerView = 'brand';
    setUrlVendor('');
    setUrlView('');
    resetScheduleState();
    var root = rootEl();
    if (root) root.classList.remove('is-vendor');
    if (hubEl) hubEl.hidden = false;
    if (vendorEl) vendorEl.hidden = true;
    if (brandEl) { brandEl.hidden = true; brandEl.innerHTML = ''; }
    if (scheduleEl) { scheduleEl.hidden = true; scheduleEl.innerHTML = ''; }
    if (viewSwitchEl) { viewSwitchEl.hidden = true; viewSwitchEl.innerHTML = ''; }
    if (noPassEl) { noPassEl.hidden = true; noPassEl.innerHTML = ''; }
    if (passesWrap) passesWrap.hidden = true;
    renderVendorMasthead(null);
    showError('');
  }

  function showVendorShell(slug) {
    selectedVendor = slug;
    setUrlVendor(slug);
    var root = rootEl();
    if (root) root.classList.add('is-vendor');
    if (hubEl) hubEl.hidden = true;
    if (vendorEl) vendorEl.hidden = false;
    if (emailRow) emailRow.hidden = !cfg.loggedIn;
    renderVendorMasthead(findVendorMeta(slug));
    showError('');
  }

  function renderVendorMasthead(meta) {
    var host = document.getElementById('lb-priv-vendor-masthead');
    if (!host) return;
    if (!meta) {
      host.innerHTML = '';
      host.hidden = true;
      return;
    }
    var name = meta.name || meta.slug_handle || '廠商';
    var logo = meta.logo_url
      ? '<img class="lb-priv__masthead-logo" src="' + escapeHtml(meta.logo_url) +
        '" alt="" width="72" height="72" loading="lazy">'
      : '<div class="lb-priv__masthead-ph" aria-hidden="true">' +
        escapeHtml(initialOf(name)) + '</div>';
    host.hidden = false;
    host.innerHTML =
      '<div class="lb-priv__masthead">' +
        logo +
        '<div class="lb-priv__masthead-text">' +
          '<div class="lb-priv__masthead-kicker">資格限定・專屬頁</div>' +
          '<h2 class="lb-priv__masthead-name">' + escapeHtml(name) + '</h2>' +
        '</div>' +
      '</div>';
  }

  function renderWall(vendors) {
    if (!wallEl) return;
    directoryCache = vendors || [];
    if (!directoryCache.length) {
      wallEl.classList.remove('is-single');
      wallEl.innerHTML =
        '<div class="lb-priv__state lb-priv__state--empty">目前尚無開放中的資格限定廠商。<br>請稍後再來，或洽詢合作品牌取得資格資訊。</div>';
      return;
    }
    if (directoryCache.length === 1) wallEl.classList.add('is-single');
    else wallEl.classList.remove('is-single');
    wallEl.innerHTML = directoryCache.map(function (v) {
      var name = v.name || v.slug_handle;
      var logo = v.logo_url
        ? '<img class="lb-priv__vcard-logo" src="' + escapeHtml(v.logo_url) +
          '" alt="" loading="lazy" width="104" height="104">'
        : '<div class="lb-priv__vcard-ph" aria-hidden="true">' +
          escapeHtml(initialOf(name)) + '</div>';
      var badge = v.has_pass
        ? '<span class="lb-priv__vcard-badge">已有通行證</span>'
        : '';
      var cue = v.has_pass
        ? '<span class="lb-priv__vcard-cue">進入專屬頁報名</span>'
        : '<span class="lb-priv__vcard-cue">點擊進入／申請資格</span>';
      var tagline = String(v.wall_tagline || '').trim();
      var taglineHtml = tagline
        ? '<span class="lb-priv__vcard-tagline">' + escapeHtml(tagline) + '</span>'
        : '';
      return (
        '<div class="lb-priv__vcard" data-vendor="' +
        escapeHtml(v.slug_handle) + '" role="button" tabindex="0">' +
        logo +
        '<span class="lb-priv__vcard-name">' + escapeHtml(name) + '</span>' +
        taglineHtml +
        badge +
        cue +
        '</div>'
      );
    }).join('');
    wallEl.querySelectorAll('[data-vendor]').forEach(function (card) {
      bindActivate(card, function () {
        openVendor(card.getAttribute('data-vendor'));
      });
    });
  }

  function loadDirectory() {
    setLoading(true);
    showError('');
    return fetchJson(proxyUrl('/private/vendor-directory'), { timeoutMs: 15000 })
      .then(function (res) {
        setLoading(false);
        if (!res.ok || !res.j || !res.j.ok) {
          var msg = (res.j && res.j.error && res.j.error.message) ||
            (res.j && res.j.message) || '無法載入廠商列表';
          showError(msg);
          renderWall([]);
          return;
        }
        renderWall(res.j.vendors || []);
      })
      .catch(function () {
        setLoading(false);
        showError('網路逾時或錯誤，請稍後再試。');
        renderWall([]);
      });
  }

  // ── Brand page ─────────────────────────────────────────────────────────
  var SECTION_TITLES = {
    HERO_CAROUSEL: '精選主打',
    FEATURED: '主打課程',
    SHELF_SCROLL: '課程系列',
    COURSE_CARD: '全部課程',
    NOTICE_BANNER: '',
    CALENDAR_EMBED: '課表'
  };

  function brandPageShell(_title, bodyHtml) {
    // Brand logo/name live in #lb-priv-vendor-masthead; body is course sections only.
    return bodyHtml || '';
  }

  function renderBrand(data, meta) {
    if (!brandEl) return;
    if (meta) renderVendorMasthead(meta);
    var slots = (data && data.slots) || [];
    var rest = (data && data.rest) || [];
    var order = [];
    var groups = {};
    var TYPE_RANK = {
      NOTICE_BANNER: 10,
      HERO_CAROUSEL: 20,
      FEATURED: 30,
      CALENDAR_EMBED: 40,
      SHELF_SCROLL: 50,
      COURSE_CARD: 70
    };
    slots.forEach(function (s) {
      if (!groups[s.section_type]) {
        groups[s.section_type] = [];
        order.push(s.section_type);
      }
      groups[s.section_type].push(s);
    });
    order.sort(function (a, b) {
      return (TYPE_RANK[a] || 80) - (TYPE_RANK[b] || 80);
    });

    var html = '';
    order.forEach(function (type) {
      var items = groups[type];
      if (type === 'NOTICE_BANNER') {
        var notice = items.filter(function (s) { return s.shelf_title; }).map(function (s) {
          return '<div class="lb-priv__notice">' + escapeHtml(s.shelf_title) + '</div>';
        }).join('');
        if (notice) html += '<div class="lb-priv__brand-section">' + notice + '</div>';
        return;
      }
      if (type === 'CALENDAR_EMBED') {
        // 與層 2 頂部「課表」分頁重複（僅 shelf_title 示範文字）；改由 vendor-schedule 呈現。
        return;
      }
      var filled = items.filter(function (s) { return s.listing; });
      if (!filled.length) return;
      if (type === 'HERO_CAROUSEL') {
        html += '<div class="lb-priv__brand-section">' +
          '<div class="lb-priv__brand-title">' + escapeHtml(SECTION_TITLES[type] || '') + '</div>' +
          renderHeroCarousel(filled) +
          '</div>';
        return;
      }
      if (type === 'FEATURED') {
        html += '<div class="lb-priv__brand-section">' +
          '<div class="lb-priv__brand-title">' + escapeHtml(SECTION_TITLES[type] || '') + '</div>' +
          '<div class="lb-priv__featured">' +
          filled.map(function (s) { return courseCard(s.listing, 'featured'); }).join('') +
          '</div></div>';
        return;
      }
      if (type === 'SHELF_SCROLL') {
        // Match portal blueprint: shelf_a / shelf_b as separate rows
        var shelfBuckets = {};
        var shelfOrder = [];
        filled.forEach(function (s) {
          var m = String(s.slot_key || '').match(/^(shelf_[a-z0-9]+)_/i);
          var key = m ? m[1].toLowerCase() : '_default';
          if (!shelfBuckets[key]) {
            shelfBuckets[key] = [];
            shelfOrder.push(key);
          }
          shelfBuckets[key].push(s);
        });
        shelfOrder.forEach(function (key) {
          var rows = shelfBuckets[key];
          var shelfTitle = (rows[0] && rows[0].shelf_title) || SECTION_TITLES[type];
          html += '<div class="lb-priv__brand-section">' +
            '<div class="lb-priv__brand-title">' + escapeHtml(shelfTitle) + '</div>' +
            '<div class="lb-priv__shelf-wrap">' +
              '<div class="lb-priv__shelf">' +
              rows.map(function (s) { return courseCard(s.listing, 'shelf'); }).join('') +
              '</div>' +
            '</div></div>';
        });
        return;
      }
      html += '<div class="lb-priv__brand-section">' +
        '<div class="lb-priv__brand-title">' + escapeHtml(SECTION_TITLES[type] || '') + '</div>' +
        '<div class="lb-priv__grid">' +
        filled.map(function (s) { return courseCard(s.listing, 'grid'); }).join('') +
        '</div></div>';
    });

    if (rest.length) {
      html += '<div class="lb-priv__brand-section">' +
        '<div class="lb-priv__brand-title">更多課程</div>' +
        '<div class="lb-priv__grid">' +
        rest.map(function (c) { return courseCard(c, 'grid'); }).join('') +
        '</div></div>';
    }

    if (!html) {
      html =
        '<div class="lb-priv__card">' +
          '<div class="lb-priv__label">專屬頁已開啟</div>' +
          '<div class="lb-priv__meta">此廠商目前尚未上架可報名的資格限定課。課程上架後會顯示在此頁。</div>' +
        '</div>';
    }
    brandEl.innerHTML = brandPageShell(null, html);
    initCarousels(brandEl);
    brandEl.hidden = false;
    if (noPassEl) noPassEl.hidden = true;
  }

  function renderPassesForVendor(passes, slug) {
    if (!passesEl || !passesWrap) return;
    var mine = (passes || []).filter(function (p) { return p.slug_handle === slug; });
    if (!mine.length) {
      passesWrap.hidden = true;
      return;
    }
    passesWrap.hidden = false;
    passesEl.innerHTML = mine.map(function (p) {
      return (
        '<div class="lb-priv__pass">' +
          '<div class="lb-priv__pass-top">' +
            '<span class="lb-priv__pass-badge">有效通行證</span>' +
          '</div>' +
          '<div class="lb-priv__pass-range">效期 ' + escapeHtml(fmt(p.starts_at)) +
            ' ～ ' + escapeHtml(fmt(p.ends_at)) + '</div>' +
        '</div>'
      );
    }).join('');
  }

  // ── No-pass / apply ────────────────────────────────────────────────────
  function renderNoPass(meta, minePayload) {
    if (!noPassEl) return;
    if (meta) renderVendorMasthead(meta);
    var req = minePayload && minePayload.request;
    var emailMasked = (minePayload && minePayload.email_masked) || '';
    var html =
      '<div class="lb-priv__gate">' +
        '<div class="lb-priv__label">尚無通行證</div>' +
        '<div class="lb-priv__meta">取得通行證並經廠商核准後，即可查看此專屬頁課程。</div>' +
      '</div>';

    if (!cfg.loggedIn) {
      html =
        '<div class="lb-priv__gate">' +
          '<div class="lb-priv__label">請先登入</div>' +
          '<div class="lb-priv__meta" style="margin-bottom:12px">登入後即可申請通行證。</div>' +
          '<a class="lb-priv__btn" href="' + escapeHtml(cfg.loginUrl || '/account/login') +
          '">登入</a>' +
        '</div>';
      noPassEl.innerHTML = html;
      noPassEl.hidden = false;
      if (brandEl) brandEl.hidden = true;
      if (passesWrap) passesWrap.hidden = true;
      return;
    }

    if (emailMasked && emailInput) emailInput.value = emailMasked;
    var reasonHint = applyReasonPlaceholder(
      (minePayload && minePayload.eligibility_reason_hint) ||
      (meta && meta.eligibility_reason_hint)
    );

    if (minePayload && minePayload.bound_other) {
      html =
        '<div class="lb-priv__gate">' +
          '<div class="lb-priv__label">無法使用此通行證</div>' +
          '<div class="lb-priv__notice">此 Email 的通行證已綁定其他會員帳號。請使用原帳號登入，或聯繫廠商協助處理。</div>' +
        '</div>';
    } else if (minePayload && minePayload.has_pass) {
      html =
        '<div class="lb-priv__gate">' +
          '<div class="lb-priv__label">已有通行證</div>' +
          '<div class="lb-priv__notice">系統顯示您已有此廠商通行證，但專屬頁暫時無法開啟。請點「重新整理」再試。</div>' +
        '</div>';
    } else if (minePayload && minePayload.has_scheduled_pass) {
      html =
        '<div class="lb-priv__gate">' +
          '<div class="lb-priv__label">通行證尚未生效</div>' +
          '<div class="lb-priv__notice">您已有此廠商的通行證，但尚未到生效時間。生效後即可進入專屬頁，無須再申請。</div>' +
        '</div>';
    } else if (req && req.status === 'PENDING') {
      html =
        '<div class="lb-priv__gate">' +
          '<div class="lb-priv__label">審核中</div>' +
          '<div class="lb-priv__notice">' +
            '已以 ' + escapeHtml(req.email_masked || emailMasked || '會員 Email') +
            ' 送出申請，請稍候廠商處理。' +
            (req.reason
              ? '<div class="lb-priv__meta" style="margin-top:8px">原因：' +
                escapeHtml(req.reason) + '</div>'
              : '') +
          '</div>' +
        '</div>';
    } else if (req && req.status === 'APPROVED') {
      html =
        '<div class="lb-priv__gate">' +
          '<div class="lb-priv__label">尚無有效通行證</div>' +
          '<div class="lb-priv__notice">' +
            '先前申請已核准，但目前沒有有效通行證（可能尚未生效、已過期或已取消）。請先「重新整理」；若仍無法進入可再次申請。' +
          '</div>' +
          applyFormHtml(emailMasked, reasonHint) +
        '</div>';
    } else if (req && req.status === 'REJECTED') {
      html =
        '<div class="lb-priv__gate">' +
          '<div class="lb-priv__label">上次申請未通過</div>' +
          '<div class="lb-priv__notice">' +
            (req.reject_reason
              ? escapeHtml(req.reject_reason)
              : '您可再次申請。') +
          '</div>' +
          applyFormHtml(emailMasked, reasonHint) +
        '</div>';
    } else {
      html =
        '<div class="lb-priv__gate">' +
          '<div class="lb-priv__label">尚無通行證</div>' +
          '<div class="lb-priv__meta">取得通行證並經廠商核准後，即可查看此專屬頁課程。</div>' +
          applyFormHtml(emailMasked, reasonHint) +
        '</div>';
    }

    noPassEl.innerHTML = html;
    noPassEl.hidden = false;
    if (brandEl) brandEl.hidden = true;
    if (passesWrap) passesWrap.hidden = true;
    bindApplyForm();
  }

  function applyReasonPlaceholder(raw) {
    var s = String(raw == null ? '' : raw).replace(/\s+/g, ' ').trim();
    return s || '例：我是〇〇學員／活動參與者';
  }

  function applyFormHtml(emailMasked, reasonHint) {
    return (
      '<div class="lb-priv__apply">' +
        '<div class="lb-priv__meta">將以會員 Email <strong>' +
          escapeHtml(emailMasked || '（登入帳號）') +
        '</strong> 申請，無法代填他人信箱。</div>' +
        '<label for="lb-priv-apply-reason" class="lb-priv__meta" style="display:block;margin:12px 0 6px">' +
          '申請原因（必填）</label>' +
        '<textarea id="lb-priv-apply-reason" maxlength="500" required aria-required="true" placeholder="' +
          escapeHtml(applyReasonPlaceholder(reasonHint)) + '"></textarea>' +
        '<div class="lb-priv__apply-actions">' +
          '<span class="lb-priv__btn" id="lb-priv-apply-submit" role="button" tabindex="0">申請通行證</span>' +
        '</div>' +
        '<div id="lb-priv-apply-msg" class="lb-priv__meta" style="margin-top:10px" hidden></div>' +
      '</div>'
    );
  }

  function bindApplyForm() {
    var btn = document.getElementById('lb-priv-apply-submit');
    bindActivate(btn, function () { submitApply(btn); });
  }

  function submitApply(btn) {
    if (!selectedVendor) return;
    var reasonEl = document.getElementById('lb-priv-apply-reason');
    var msgEl = document.getElementById('lb-priv-apply-msg');
    var reason = reasonEl ? String(reasonEl.value || '').trim() : '';
    if (!reason) {
      if (msgEl) {
        msgEl.hidden = false;
        msgEl.textContent = '請填寫申請原因';
      }
      if (reasonEl) reasonEl.focus();
      return;
    }
    setBusy(btn, true);
    if (msgEl) {
      msgEl.hidden = false;
      msgEl.textContent = '送出中…';
    }
    fetchJson(proxyUrl('/private/eligibility-request'), {
      method: 'POST',
      body: { vendor: selectedVendor, reason: reason },
      timeoutMs: 15000
    })
      .then(function (res) {
        if (!res.ok || !res.j || !res.j.ok) {
          var errMsg = (res.j && res.j.error && res.j.error.message) ||
            (res.j && res.j.message) || '申請失敗';
          if (msgEl) msgEl.textContent = errMsg;
          setBusy(btn, false);
          return;
        }
        openVendor(selectedVendor);
      })
      .catch(function () {
        if (msgEl) msgEl.textContent = '網路錯誤，請稍後再試';
        setBusy(btn, false);
      });
  }

  function hideLayerViews() {
    if (viewSwitchEl) { viewSwitchEl.hidden = true; viewSwitchEl.innerHTML = ''; }
    if (scheduleEl) { scheduleEl.hidden = true; scheduleEl.innerHTML = ''; }
  }

  function renderViewSwitch() {
    if (!viewSwitchEl) return;
    var surface = normalizeLearnerSurface(learnerSurface);
    if (!(surface.show_brand_page && surface.show_schedule)) {
      viewSwitchEl.hidden = true;
      viewSwitchEl.innerHTML = '';
      return;
    }
    viewSwitchEl.hidden = false;
    viewSwitchEl.innerHTML =
      '<span class="lb-priv__view-chip' + (layerView === 'brand' ? ' is-active' : '') +
        '" role="button" tabindex="0" data-layer-view="brand">專屬頁</span>' +
      '<span class="lb-priv__view-chip' + (layerView === 'schedule' ? ' is-active' : '') +
        '" role="button" tabindex="0" data-layer-view="schedule">課表</span>';
  }

  function applyLayerView() {
    layerView = resolveLayerView(layerView);
    renderViewSwitch();
    setUrlView(layerView === 'schedule' ? 'schedule' : '');
    if (layerView === 'schedule') {
      if (brandEl) brandEl.hidden = true;
      if (scheduleEl) scheduleEl.hidden = false;
      ensureScheduleLoaded();
    } else {
      if (scheduleEl) scheduleEl.hidden = true;
      if (brandEl) {
        brandEl.hidden = false;
        if (brandPayloadCache) renderBrand(brandPayloadCache, findVendorMeta(selectedVendor));
      }
    }
  }

  function setLayerView(view) {
    layerView = resolveLayerView(view === 'schedule' ? 'schedule' : 'brand');
    applyLayerView();
  }

  function pickInitialCalCursor(courses) {
    var today = ymdTPE(new Date());
    var hasToday = courses.some(function (c) { return courseYmd(c) === today; });
    if (hasToday) return monthStart(new Date());
    var now = Date.now();
    var best = null;
    courses.forEach(function (c) {
      if (!c.start_at) return;
      var d = new Date(c.start_at);
      if (Number.isNaN(d.getTime()) || d.getTime() < now) return;
      if (!best || d.getTime() < best.getTime()) best = d;
    });
    return monthStart(best || new Date());
  }

  function ensureScheduleLoaded() {
    if (!selectedVendor || !scheduleEl) return;
    if (scheduleLoadedFor === selectedVendor) {
      // Still refresh tickets for registered-dedupe when opening 可報名.
      ensureTicketsLoaded(true).then(function () {
        pruneInvalidSelections();
        renderSchedule();
      });
      return;
    }
    scheduleEl.innerHTML = '<div class="lb-priv__state">載入課表…</div>';
    Promise.all([
      fetchJson(proxyUrlWith('/private/vendor-schedule', { vendor: selectedVendor }), {
        timeoutMs: 15000
      }),
      ensureTicketsLoaded(true)
    ]).then(function (bundle) {
      var res = bundle[0];
      if (!res.ok || !res.j || !res.j.ok) {
        var msg = (res.j && res.j.error && res.j.error.message) || '無法載入課表';
        scheduleEl.innerHTML =
          '<div class="lb-priv__state lb-priv__state--error">' + escapeHtml(msg) + '</div>';
        return;
      }
      scheduleCourses = Array.isArray(res.j.courses) ? res.j.courses : [];
      scheduleNotices = Array.isArray(res.j.notices) ? res.j.notices : [];
      if (res.j.learner_surface) {
        learnerSurface = normalizeLearnerSurface(res.j.learner_surface);
      }
      scheduleLoadedFor = selectedVendor;
      scheduleCalCursor = pickInitialCalCursor(scheduleCourses);
      pruneInvalidSelections();
      renderSchedule();
    }).catch(function () {
      scheduleEl.innerHTML =
        '<div class="lb-priv__state lb-priv__state--error">課表載入失敗，請稍後再試。</div>';
    });
  }

  /**
   * @param {boolean} [force]
   * @returns {Promise<{ok: boolean, tickets?: Array}>}
   */
  function ensureTicketsLoaded(force) {
    if (!selectedVendor) return Promise.resolve({ ok: false, reason: 'no_vendor' });
    if (!force && ticketsLoadedFor === selectedVendor && !ticketsLoadFailed) {
      return Promise.resolve({ ok: true, tickets: scheduleTickets });
    }
    return fetchJson(
      proxyUrlWith('/customer-tickets/list', {
        vendor_slug: selectedVendor,
        listing_mode: 'PRIVATE',
        limit: '200',
        page: '1'
      }),
      { timeoutMs: 15000 }
    ).then(function (res) {
      if (!res.ok || !res.j || !res.j.ok) {
        scheduleTickets = [];
        ticketsLoadedFor = '';
        ticketsLoadFailed = true;
        return { ok: false, reason: 'tickets_failed' };
      }
      scheduleTickets = Array.isArray(res.j.data) ? res.j.data : [];
      ticketsLoadedFor = selectedVendor;
      ticketsLoadFailed = false;
      return { ok: true, tickets: scheduleTickets };
    }).catch(function () {
      scheduleTickets = [];
      ticketsLoadedFor = '';
      ticketsLoadFailed = true;
      return { ok: false, reason: 'tickets_failed' };
    });
  }

  function ticketStatusKey(t) {
    var label = String((t && t.state_label) || '').trim();
    var raw = String((t && (t.state || t.ticket_status)) || '').toUpperCase();
    if (t && (t.redeemed || t.redeemed_at || /已使用/.test(label))) return 'used';
    if (/VOID|CANCEL|REFUND|取消/.test(raw + label)) return 'void';
    if (/EXPIRED|已過期/.test(raw + label) || String(t.state || '').toLowerCase() === 'expired') {
      return 'expired';
    }
    if (
      t &&
      (t.awaits_vendor_payment_confirm ||
        raw === 'PENDING_VENDOR_CONFIRM' ||
        String(t.state || '').toLowerCase() === 'pending_vendor')
    ) {
      return 'pending_vendor';
    }
    return 'usable';
  }

  function renderScheduleList() {
    var items = scheduleMode === 'registered' ? scheduleTickets : scheduleCourses;
    var filtered = items.filter(function (it) {
      if (!scheduleDayFilter) return true;
      return (scheduleMode === 'registered' ? ticketYmd(it) : courseYmd(it)) === scheduleDayFilter;
    });

    if (scheduleMode === 'registered') {
      // Prefer active-ish first; keep void/expired but muted at end
      var rank = { usable: 0, pending_vendor: 1, used: 2, expired: 3, void: 4 };
      filtered = filtered.slice().sort(function (a, b) {
        var ra = rank[ticketStatusKey(a)] != null ? rank[ticketStatusKey(a)] : 9;
        var rb = rank[ticketStatusKey(b)] != null ? rank[ticketStatusKey(b)] : 9;
        if (ra !== rb) return ra - rb;
        return String(a.event_start_at || '').localeCompare(String(b.event_start_at || ''));
      });
    } else {
      filtered = filtered.slice().sort(function (a, b) {
        return String(a.start_at || '').localeCompare(String(b.start_at || ''));
      });
    }

    var noticeYmds = [];
    if (scheduleDayFilter) {
      if (noticesForYmd(scheduleDayFilter).length) noticeYmds.push(scheduleDayFilter);
    } else if (scheduleCalCursor) {
      expandNoticesForMonth(
        scheduleNotices,
        scheduleCalCursor.getFullYear(),
        scheduleCalCursor.getMonth() + 1
      ).forEach(function (n) {
        if (noticeYmds.indexOf(n.ymd) < 0) noticeYmds.push(n.ymd);
      });
    }

    if (!filtered.length && !noticeYmds.length) {
      return '<div class="lb-priv__sched-empty">' +
        (scheduleMode === 'registered'
          ? (scheduleDayFilter ? '這天沒有已報名課程。' : '尚無已報名課程。')
          : (scheduleDayFilter ? '這天沒有可報名課程。' : '目前沒有可報名課程。')) +
        '</div>';
    }

    var byDay = {};
    var dayOrder = [];
    noticeYmds.forEach(function (ymd) {
      if (!byDay[ymd]) {
        byDay[ymd] = [];
        dayOrder.push(ymd);
      }
    });
    filtered.forEach(function (it) {
      var ymd = scheduleMode === 'registered' ? ticketYmd(it) : courseYmd(it);
      var key = ymd || 'undated';
      if (!byDay[key]) {
        byDay[key] = [];
        dayOrder.push(key);
      }
      byDay[key].push(it);
    });
    dayOrder.sort(function (a, b) {
      if (a === 'undated') return 1;
      if (b === 'undated') return -1;
      return a < b ? -1 : a > b ? 1 : 0;
    });

    return '<div class="lb-priv__sched-list">' + dayOrder.map(function (day) {
      var label = day === 'undated' ? '日期未定' : weekdayLabelTPE(day);
      var noticeHtml = noticesForYmd(day).map(renderNoticeRow).join('');
      var rows = byDay[day].map(function (it) {
        if (scheduleMode === 'registered') {
          var st = ticketStatusKey(it);
          var stLabel = it.state_label || ({
            usable: '可使用',
            pending_vendor: '待確認',
            used: '已使用',
            void: '已取消',
            expired: '已過期'
          })[st] || st;
          var muted = st === 'void' || st === 'expired' ? ' is-muted' : '';
          var badgeClass = st === 'usable' ? '' : ' lb-priv__sched-badge--' + st;
          var ticketsHref = myTicketsHrefFor(it);
          var orderHref = accountOrderHrefFor(it);
          // Lightweight: account order page（顧客在此申請退貨／退票；非我的票券）
          var refundLink = (st === 'usable' && orderHref)
            ? ('<a class="lb-priv__link lb-priv__link--refund" href="' +
                escapeHtml(orderHref) +
                '" title="前往訂單頁申請退票（依平台退票規則）">退票</a>')
            : '';
          return (
            '<div class="lb-priv__sched-row' + muted + '">' +
              '<div>' +
                '<div class="lb-priv__sched-row-title">' +
                  escapeHtml(it.event_title || it.product_title || '課程') +
                '</div>' +
                '<div class="lb-priv__sched-row-meta">' +
                  escapeHtml(ticketScheduleMeta(it)) +
                '</div>' +
              '</div>' +
              '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap">' +
                refundLink +
                '<span class="lb-priv__sched-badge' + badgeClass + '">' + escapeHtml(stLabel) + '</span>' +
                '<a class="lb-priv__link" href="' + escapeHtml(ticketsHref) + '">查看票券</a>' +
              '</div>' +
            '</div>'
          );
        }
        var full = !!it.is_full;
        var ended = isCourseEnded(it);
        var href = it.product_url || productUrl(it.shopify_product_id, it.title);
        var canQuick = courseSelectable(it);
        var selected = !!scheduleSelected[String(it.id)];
        var priceHint = canQuick ? coursePriceHint(it) : '';
        var meta = escapeHtml(scheduleCourseMeta(it, priceHint));
        var already = isAlreadyRegistered(it);
        if (already) {
          return (
            '<div class="lb-priv__sched-row is-muted">' +
              '<div>' +
                '<div class="lb-priv__sched-row-title">' + escapeHtml(it.title || '課程') + '</div>' +
                '<div class="lb-priv__sched-row-meta">' + meta + '</div>' +
              '</div>' +
              '<span class="lb-priv__sched-badge lb-priv__sched-badge--used">已報名</span>' +
            '</div>'
          );
        }
        if (ended) {
          return (
            '<div class="lb-priv__sched-row is-muted is-ended">' +
              '<div>' +
                '<div class="lb-priv__sched-row-title">' + escapeHtml(it.title || '課程') + '</div>' +
                '<div class="lb-priv__sched-row-meta">' + meta + '</div>' +
              '</div>' +
              '<span class="lb-priv__sched-badge lb-priv__sched-badge--ended">已結束</span>' +
            '</div>'
          );
        }
        if (canQuick) {
          return (
            '<div class="lb-priv__sched-row lb-priv__sched-row--pick' +
              (selected ? ' is-selected' : '') +
              '" data-sched-pick="' + escapeHtml(String(it.id)) + '" role="button" tabindex="0">' +
              '<div class="lb-priv__sched-pick">' +
                '<span class="lb-priv__sched-check" aria-hidden="true">' + (selected ? '✓' : '') + '</span>' +
                '<div>' +
                  '<div class="lb-priv__sched-row-title">' + escapeHtml(it.title || '課程') + '</div>' +
                  '<div class="lb-priv__sched-row-meta">' + meta + '</div>' +
                '</div>' +
              '</div>' +
              '<span class="lb-priv__link">' + (selected ? '已選' : '選擇') + '</span>' +
            '</div>'
          );
        }
        var inner =
          '<div>' +
            '<div class="lb-priv__sched-row-title">' + escapeHtml(it.title || '課程') + '</div>' +
            '<div class="lb-priv__sched-row-meta">' + meta + '</div>' +
          '</div>' +
          (full
            ? '<span class="lb-priv__sched-badge">已額滿</span>'
            : '<span class="lb-priv__link">前往報名</span>');
        if (full || !href) {
          return '<div class="lb-priv__sched-row' + (full ? ' is-full' : '') + '">' + inner + '</div>';
        }
        return '<a class="lb-priv__sched-row" href="' + escapeHtml(href) + '">' + inner + '</a>';
      }).join('');
      return (
        '<div class="lb-priv__sched-day-group">' +
          '<div class="lb-priv__sched-day-label">' + escapeHtml(label) + '</div>' +
          noticeHtml +
          rows +
        '</div>'
      );
    }).join('') + '</div>';
  }

  function renderScheduleMarks(count) {
    if (!(count > 0)) return '';
    var n = Math.min(count, 3);
    var dots = '';
    for (var i = 0; i < n; i++) dots += '<i class="lb-priv__sched-dot" aria-hidden="true"></i>';
    var more = count > 3
      ? '<span class="lb-priv__sched-more">+' + (count - 3) + '</span>'
      : '';
    return '<span class="lb-priv__sched-marks" aria-hidden="true">' + dots + more + '</span>';
  }

  function renderScheduleCalendar(sourceItems) {
    if (!scheduleCalCursor) scheduleCalCursor = monthStart(new Date());
    var y = scheduleCalCursor.getFullYear();
    var m = scheduleCalCursor.getMonth();
    var byDay = {};
    sourceItems.forEach(function (it) {
      var ymd = scheduleMode === 'registered' ? ticketYmd(it) : courseYmd(it);
      if (!ymd) return;
      byDay[ymd] = (byDay[ymd] || 0) + 1;
    });
    var noticeByDay = {};
    expandNoticesForMonth(scheduleNotices, y, m + 1).forEach(function (n) {
      if (!noticeByDay[n.ymd]) noticeByDay[n.ymd] = [];
      noticeByDay[n.ymd].push(n);
    });
    var todayYmd = ymdTPE(new Date());
    var first = new Date(y, m, 1);
    var startPad = (first.getDay() + 6) % 7;
    var daysInMonth = new Date(y, m + 1, 0).getDate();
    var dow = ['一', '二', '三', '四', '五', '六', '日'];
    var modeTone = scheduleMode === 'registered' ? 'mine' : 'open';
    var html =
      '<div class="lb-priv__sched-cal lb-priv__sched-cal--' + modeTone + '">' +
        '<div class="lb-priv__sched-cal-bar">' +
          '<div class="lb-priv__sched-nav">' +
            '<span class="lb-priv__sched-nav-btn" role="button" tabindex="0" data-sched-prev aria-label="上一月">‹</span>' +
            '<strong class="lb-priv__sched-month">' + y + ' 年 ' + pad2(m + 1) + ' 月</strong>' +
            '<span class="lb-priv__sched-nav-btn" role="button" tabindex="0" data-sched-next aria-label="下一月">›</span>' +
            '<span class="lb-priv__sched-today" role="button" tabindex="0" data-sched-today>今日</span>' +
          '</div>' +
          (scheduleDayFilter
            ? '<span class="lb-priv__sched-clear" role="button" tabindex="0" data-sched-clear>清除日期</span>'
            : '') +
        '</div>' +
        '<div class="lb-priv__sched-cal-grid">';
    dow.forEach(function (d) {
      html += '<div class="lb-priv__sched-dow">' + d + '</div>';
    });
    for (var i = 0; i < startPad; i++) {
      html += '<div class="lb-priv__sched-cell lb-priv__sched-cell--pad"></div>';
    }
    for (var day = 1; day <= daysInMonth; day++) {
      var ymd = y + '-' + pad2(m + 1) + '-' + pad2(day);
      var count = byDay[ymd] || 0;
      var dayNotices = noticeByDay[ymd] || [];
      var has = count > 0 || dayNotices.length > 0;
      var cls = 'lb-priv__sched-cell';
      if (has) {
        cls += ' lb-priv__sched-cell--has lb-priv__sched-cell--' + modeTone;
      }
      if (dayNotices.length) cls += ' lb-priv__sched-cell--notice';
      if (ymd === todayYmd) cls += ' is-today';
      if (scheduleDayFilter === ymd) cls += ' is-selected';
      var aria = ymd;
      if (dayNotices.length) aria += '，' + dayNotices.length + ' 項每日事項';
      if (count) aria += '，' + count + ' 堂課';
      html +=
        '<div class="' + cls + '"' +
        (has ? ' role="button" tabindex="0" data-sched-day="' + ymd + '" aria-label="' + aria + '"' : '') +
        '>' +
          '<span class="lb-priv__sched-daynum">' + day + '</span>' +
          dayNotices.map(function (n) { return renderNoticeChip(n); }).join('') +
          renderScheduleMarks(count) +
        '</div>';
    }
    html += '</div></div>';
    return html;
  }

  function renderSchedule() {
    if (!scheduleEl) return;
    var source = scheduleMode === 'registered' ? scheduleTickets : scheduleCourses;
    var ticketsBanner = ticketsLoadFailed
      ? '<div class="lb-priv__state lb-priv__state--error" style="margin:8px 0">' +
          '無法確認已報名狀態，暫不可快速勾選報名。請重新整理後再試，或改從商品頁報名。' +
        '</div>'
      : '';
    scheduleEl.innerHTML =
      renderScheduleCalendar(source) +
      '<div class="lb-priv__sched-modes">' +
        '<span class="lb-priv__view-chip' + (scheduleMode === 'open' ? ' is-active' : '') +
          '" role="button" tabindex="0" data-sched-mode="open">可報名</span>' +
        '<span class="lb-priv__view-chip' + (scheduleMode === 'registered' ? ' is-active' : '') +
          '" role="button" tabindex="0" data-sched-mode="registered">已報名</span>' +
      '</div>' +
      ticketsBanner +
      (scheduleMode === 'open'
        ? '<p class="lb-priv__sched-tip">可勾選多堂課，一次填寫學員資料後結帳。</p>'
        : '') +
      renderScheduleList();
    renderQuickBar();
  }

  function bindScheduleUiOnce() {
    if (!vendorEl || vendorEl.getAttribute('data-sched-bound') === '1') return;
    vendorEl.setAttribute('data-sched-bound', '1');
    vendorEl.addEventListener('click', function (e) {
      var viewChip = e.target.closest('[data-layer-view]');
      if (viewChip) {
        setLayerView(viewChip.getAttribute('data-layer-view') || 'brand');
        return;
      }
      if (!scheduleEl || scheduleEl.hidden) return;
      if (e.target.closest('[data-sched-prev]')) {
        scheduleCalCursor = new Date(scheduleCalCursor.getFullYear(), scheduleCalCursor.getMonth() - 1, 1);
        renderSchedule();
        return;
      }
      if (e.target.closest('[data-sched-next]')) {
        scheduleCalCursor = new Date(scheduleCalCursor.getFullYear(), scheduleCalCursor.getMonth() + 1, 1);
        renderSchedule();
        return;
      }
      if (e.target.closest('[data-sched-today]')) {
        var today = ymdTPE(new Date());
        scheduleCalCursor = monthStart(new Date());
        var source = scheduleMode === 'registered' ? scheduleTickets : scheduleCourses;
        var has = source.some(function (it) {
          return (scheduleMode === 'registered' ? ticketYmd(it) : courseYmd(it)) === today;
        }) || noticesForYmd(today).length > 0;
        scheduleDayFilter = has ? today : null;
        renderSchedule();
        return;
      }
      if (e.target.closest('[data-sched-clear]')) {
        scheduleDayFilter = null;
        renderSchedule();
        return;
      }
      var dayEl = e.target.closest('[data-sched-day]');
      if (dayEl) {
        var ymd = dayEl.getAttribute('data-sched-day') || '';
        scheduleDayFilter = scheduleDayFilter === ymd ? null : ymd;
        renderSchedule();
        return;
      }
      var modeEl = e.target.closest('[data-sched-mode]');
      if (modeEl) {
        var mode = modeEl.getAttribute('data-sched-mode') || 'open';
        scheduleMode = mode === 'registered' ? 'registered' : 'open';
        if (scheduleMode === 'registered') {
          ensureTicketsLoaded(true).then(function () { renderSchedule(); });
        } else {
          renderSchedule();
        }
        return;
      }
      var pickEl = e.target.closest('[data-sched-pick]');
      if (pickEl) {
        var pid = pickEl.getAttribute('data-sched-pick') || '';
        toggleSelectCourse(pid, !scheduleSelected[pid]);
        renderSchedule();
      }
    });
  }

  function openVendor(slug) {
    if (!slug) return;
    var meta = findVendorMeta(slug);
    if (selectedVendor && selectedVendor !== slug) resetScheduleState();
    showVendorShell(slug);
    setLoading(true);
    hideLayerViews();
    if (brandEl) {
      brandEl.hidden = false;
      brandEl.innerHTML = brandPageShell(
        meta.name || slug,
        '<div class="lb-priv__state">載入中…</div>'
      );
    }
    if (noPassEl) noPassEl.hidden = true;

    if (!cfg.loggedIn) {
      setLoading(false);
      renderNoPass(meta, null);
      return;
    }

    var reqId = ++brandReqSeq;
    Promise.all([
      fetchJson(proxyUrlWith('/private/brand-page', { vendor: slug }), { timeoutMs: 15000 }),
      fetchJson(proxyUrlWith('/private/eligibility-request/mine', { vendor: slug }), {
        timeoutMs: 15000
      }),
      fetchJson(proxyUrl('/private/my-courses'), { timeoutMs: 15000 })
    ])
      .then(function (bundle) {
        if (reqId !== brandReqSeq) return;
        setLoading(false);
        var brandRes = bundle[0];
        var mineRes = bundle[1];
        var coursesRes = bundle[2];

        if (coursesRes.ok && coursesRes.j && coursesRes.j.ok) {
          if (emailInput && coursesRes.j.email_masked) {
            emailInput.value = coursesRes.j.email_masked;
          }
        }

        if (brandRes.ok && brandRes.j && brandRes.j.ok) {
          brandPayloadCache = brandRes.j;
          learnerSurface = normalizeLearnerSurface(brandRes.j.learner_surface);
          if (coursesRes.ok && coursesRes.j && coursesRes.j.ok) {
            renderPassesForVendor(coursesRes.j.passes || [], slug);
          }
          layerView = pickInitialLayerView();
          bindScheduleUiOnce();
          applyLayerView();
          return;
        }

        hideLayerViews();
        var code = brandRes.j && brandRes.j.error && brandRes.j.error.code;
        if (brandRes.status === 401 || code === 'LOGIN_REQUIRED') {
          cfg.loggedIn = false;
          if (emailRow) emailRow.hidden = true;
          renderNoPass(meta, null);
          return;
        }
        if (
          brandRes.status === 403 ||
          code === 'NO_PASS_FOR_VENDOR' ||
          code === 'ELIGIBILITY_BOUND_OTHER'
        ) {
          var minePayload =
            mineRes.ok && mineRes.j && mineRes.j.ok
              ? mineRes.j
              : { request: null, email_masked: '' };
          if (code === 'ELIGIBILITY_BOUND_OTHER') {
            minePayload = Object.assign({}, minePayload, {
              has_pass: false,
              has_scheduled_pass: false,
              bound_other: true
            });
          }
          renderNoPass(meta, minePayload);
          return;
        }

        var msg = (brandRes.j && brandRes.j.error && brandRes.j.error.message) ||
          (brandRes.j && brandRes.j.message) ||
          '無法載入廠商頁面';
        if (brandEl) {
          brandEl.innerHTML = brandPageShell(
            meta.name || slug,
            '<div class="lb-priv__state lb-priv__state--error">' + escapeHtml(msg) + '</div>'
          );
          brandEl.hidden = false;
        }
      })
      .catch(function () {
        if (reqId !== brandReqSeq) return;
        setLoading(false);
        hideLayerViews();
        if (brandEl) {
          brandEl.innerHTML = brandPageShell(
            meta.name || slug,
            '<div class="lb-priv__state lb-priv__state--error">網路逾時或錯誤，請稍後再試。</div>'
          );
          brandEl.hidden = false;
        }
      });
  }

  function boot() {
    if (emailInput) {
      emailInput.readOnly = true;
      if (cfg.customerEmail) emailInput.value = cfg.customerEmail;
    }
    bindActivate(backBtn, function () {
      showHub();
      if (!directoryCache.length) loadDirectory();
    });
    bindActivate(refreshBtn, function () {
      if (selectedVendor) {
        resetScheduleState();
        openVendor(selectedVendor);
      } else loadDirectory();
    });
    bindScheduleUiOnce();

    var initialVendor = queryVendorParam();
    if (queryViewParam() === 'schedule') layerView = 'schedule';
    loadDirectory().then(function () {
      if (initialVendor) openVendor(initialVendor);
      else showHub();
    });
  }

  boot();
})();
/* refund-link3 account.ladybaeshop.com/orders/ */
